import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { style } from "./Chat.css";
import User from "../Image/user.svg";
import UserRobot from "../Image/userRobot.svg";

const Chat = ({ message, exampleAnswer, msgRef }) => {
  useEffect(() => {
    if (msgRef.current) {
      msgRef.current.scrollIntoView({ behavior: "smooth" });
    }
  });

  return (
    <Box sx={style.parentChatBox}>
      <Box sx={style.questionParent}>
        <Box sx={style.questionBox}>
          <Typography sx={style.chatText}>{message}</Typography>
        </Box>
        <Box component="img" src={User} sx={style.userIcon} />
      </Box>
      {exampleAnswer && (
        <Box sx={style.answerParent}>
          <Box component="img" src={UserRobot} sx={style.userIcon2} />
          <Box>
            <Box sx={style.answerBox} ref={msgRef}>
              <Typography sx={style.chatText}>
                {<div dangerouslySetInnerHTML={{ __html: exampleAnswer }} />}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Chat;
